<template>
    <footer class="footer text-center">
        <div class="container">
            <span class="text-muted"
                >A practice project developed by
                <a href="https://artisanasif.com" target="_blank">Asif</a></span
            >
        </div>
    </footer>
</template>

<style scoped>
footer {
    background-color: #edeff2;
    padding: 1rem;
    margin-top: auto;
}
</style>
